import { Theme } from '@mui/system'
import { makeStyles } from '@mui/styles'
import { FONTS, SPACES } from 'src/constants'

const useStyles = makeStyles((theme: Theme) => ({
  form: {
    '&&': {
      display: 'flex',

      [theme.breakpoints.down('tablet')]: {
        alignItems: 'center',
        flexDirection: 'column',
      },

      [theme.breakpoints.up('tablet')]: {
        gap: SPACES.xxxxxxl,
        flexWrap: 'wrap',
      },
    },
  },
  formWrapper: {
    '&&': {
      position: 'relative',
      flexDirection: 'column',

      [theme.breakpoints.down('tablet')]: {
        alignItems: 'center',
        gap: SPACES.xxl,
        marginBottom: SPACES.xxl,
      },

      [theme.breakpoints.up('tablet')]: {
        gap: '2.5rem',

        maxWidth: 800,
      },
      [theme.breakpoints.up('laptop')]: {
        padding: SPACES.xs,
        maxWidth: 840,
      },
    },
  },
  ownerWrapper: {
    width: '100%',

    display: 'flex',
    flexDirection: 'column',
    gap: SPACES.xs,
  },
  changeOwnerWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  changeOwnerLink: {
    '&&': {
      textTransform: 'none',
      fontSize: FONTS.SIZES.s,
      fontWeight: FONTS.WEIGHTS.bold,
    },
  },
  mainImageWrapper: {
    '&&': {
      marginRight: 'auto',
    },
  },
  upperWrapper: {
    '&&': {
      display: 'flex',
      flexDirection: 'column',

      [theme.breakpoints.down('tablet')]: {
        width: '100%',
        gap: SPACES.xxl,
      },
      [theme.breakpoints.up('tablet')]: {
        flexWrap: 'nowrap',
        maxHeight: 200,
        justifyContent: 'space-between',
        gap: SPACES.xxxxxl,
      },
    },
  },
  inputsWrapper: {
    '&&': {
      display: 'flex',
      gap: SPACES.xxl,

      [theme.breakpoints.down('tablet')]: {
        width: '100%',
        flexDirection: 'column',
        alignItems: 'center',
      },

      [theme.breakpoints.up('tablet')]: {
        justifyContent: 'space-between',
      },
    },
  },

  websitesWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',

    [theme.breakpoints.down('tablet')]: {
      width: '100%',
      gap: SPACES.xxl,
    },
    [theme.breakpoints.up('tablet')]: {
      gap: SPACES.xs,
    },
  },
  inputWrapper: {
    '&&': {
      width: '100%',
      gap: SPACES.xs,

      display: 'flex',
      flexDirection: 'column',
      alignItems: 'end',
    },
  },
  buttonsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: SPACES.m,

    [theme.breakpoints.down('tablet')]: {
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  existsWrapper: {
    display: 'flex',
    flexDirection: 'column',

    [theme.breakpoints.down('tablet')]: {
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  descriptionWrapper: {
    '&&': {
      position: 'relative',
      width: '100%',

      display: 'flex',
      flexDirection: 'column',
      alignItems: 'end',
    },
  },
  existsText: {
    '&&': {
      marginBottom: SPACES.xs,

      color: theme.palette.custom.darkBlue2,
      fontSize: FONTS.SIZES.s,
      lineHeight: 1.33,
      fontWeight: FONTS.WEIGHTS.medium,
    },
  },
}))

export default useStyles
